export default __webpack_public_path__ + "static/media/690937.53bc3cee.png";